import repository from './repsitory'

const resource = '/tanks'

export default {
    getCurrent (targetId) {
        return repository.get(`${resource}/history/current/${targetId}`)
    },
    get (targetId) {
        return repository.get(`${resource}/${targetId}`)
    },
    getByDate (targetId) {
        return repository.get(`${resource}/history/date/${targetId}`)
    },
    getHistoryListRangeDate (data) {
        return repository.post(`${resource}/history/list/range`, data)
   },
    updateMinimums (data, targetDeviceId) {
        return repository.put(`${resource}/minimums/${targetDeviceId}`, data)
    },
}
